import { createTheme } from '../utils/create-theme';
export var COPPER_THEME = createTheme('copper', {
  activeMode: 'light',
  light: {
    color: {
      lineMid: '#00000022',
      appChrome: '#F5F5F5',
      primary: '#4B9A7E',
      primaryLight: '#81b8a5',
      primaryLighter: '#a5cdbf',
      primaryDarker: '#162e26',
      primaryBright: '#448b71',
      primaryVeryLight: '#dbebe5',
      secondary: '#333333',
      link: '#4B9A7E',
      linkHover: '#162e26',
      navigationActive: '#4B9A7E',
      accentDark: '#162e26',
      accentLight: '#81b8a5'
    }
  },
  dark: {
    color: {
      link: '#7DB248',
      linkHover: '#7DB248'
    }
  }
});
export default COPPER_THEME;